import { render, staticRenderFns } from "./AboutDeveloper.vue?vue&type=template&id=547a811e&"
import script from "./AboutDeveloper.vue?vue&type=script&lang=ts&"
export * from "./AboutDeveloper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports